"use client";

import { useEffect } from "react";
import { sendGTMEvent } from "@next/third-parties/google";
import { PolicyContentBase } from "./PolicyContentBase";

export const RefundPolicyContent: React.FC<{ initialPolicy?: any }> = ({ initialPolicy }) => {
  useEffect(() => {
    // --- GOOGLE ANALYTICS: Event Tracking ---
    try {
      sendGTMEvent({
        event: "page_view_manual",
        page_name: "refund_policy",
      });
    } catch (error) {
      console.debug("GTM event error:", error);
    }
  }, []);

  return (
    <PolicyContentBase
      apiEndpoint="/api/refund-policy"
      defaultTitle="Refund Policy"
      initialPolicy={initialPolicy}
    />
  );
};
